(function ($) {
  'use strict';

  var MOBILE_QUERY = window.matchMedia('(max-width: 767px)');

  function shouldUseSlider($carousel) {
    var count = parseInt($carousel.data('review-count'), 10) || 0;
    if (count <= 0) return false;
    return MOBILE_QUERY.matches || count > 2;
  }

  function sliderOptions($carousel) {
    var count = parseInt($carousel.data('review-count'), 10) || 0;
    var isMobile = MOBILE_QUERY.matches;
    var slidesToShow = isMobile ? 1 : 2;
    var showControls = count > slidesToShow;

    return {
      swipeToSlide: true,
      arrows: showControls,
      dots: showControls,
      infinite: false,
      slidesToShow: slidesToShow,
      slidesToScroll: 1,
      adaptiveHeight: true
    };
  }

  function destroySlider($carousel) {
    if ($carousel.hasClass('slick-initialized')) {
      $carousel.slick('unslick');
    }
    $carousel.removeClass('slick-carousel is-slider-active row g-3');
  }

  function initCarousel($carousel) {
    if (!$carousel.length) return;

    if (!shouldUseSlider($carousel)) {
      destroySlider($carousel);
      return;
    }

    if (!$carousel.hasClass('slick-initialized')) {
      $carousel.addClass('slick-carousel is-slider-active row g-3');
      $carousel.slick(sliderOptions($carousel));
      return;
    }

    $carousel.slick('slickSetOption', sliderOptions($carousel), true);
    $carousel.slick('setPosition');
  }

  function initLayvoReviewSliders() {
    $('.js-layvo-reviews-carousel').each(function () {
      initCarousel($(this));
    });
  }

  $(document).ready(initLayvoReviewSliders);

  if (MOBILE_QUERY.addEventListener) {
    MOBILE_QUERY.addEventListener('change', initLayvoReviewSliders);
  }

  $(document).on('shopify:section:load', initLayvoReviewSliders);

  $('.more-info-tabs__nav-link, .product-tabs__nav-link').on('shown.bs.tab', function () {
    var $panel = $($(this).attr('href'));
    $panel.find('.js-layvo-reviews-carousel').each(function () {
      var $carousel = $(this);
      if ($carousel.hasClass('slick-initialized')) {
        $carousel.slick('setPosition');
      } else {
        initCarousel($carousel);
      }
    });
  });
})(jQuery);
